import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFetchApi } from "@itarget/shared";
import { auth } from "../redux";
import { buildPersonMeUrl, readAssociationId } from "../utils/association";

export const useAssociationId = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const accessToken = user?.access_token;
  const personId = user?.data?.id;
  const associationId = user?.data?.associacao_id;

  const { fetchData: fetchMe } = useFetchApi(buildPersonMeUrl(), "GET", {
    Authorization: `Bearer ${accessToken}`,
  });

  useEffect(() => {
    if (!accessToken || !personId || associationId !== undefined) {
      return undefined;
    }

    let cancelled = false;

    fetchMe().then((me) => {
      if (cancelled || !me) {
        return;
      }
      dispatch(
        auth.actions.updateUser({
          ...user,
          data: { ...user.data, associacao_id: readAssociationId(me) },
        })
      );
    });

    return () => {
      cancelled = true;
    };
  }, [accessToken, personId, associationId, user, fetchMe, dispatch]);

  return associationId;
};
